export default __webpack_public_path__ + "static/media/ic-pie.0b45a69d.svg";